export default "__VITE_ASSET__68e8bb04__"